import React from "react";
import { Button } from "~components";
import cn from "classnames";
import { useCartContext, useProductContext } from "~hooks";
import { GatsbyImage } from "gatsby-plugin-image";
import * as styles from "./styles.module.scss";

const CartUpsellCard = () => {
  const {
    getCartUpsellProductId,
    setIsCartUpsellWindowOpen,
    setCartUpsellProductIds,
    numberOfItemsInCart,
    getCartDiscountPercentage
  } = useCartContext();

  const { getProductData } = useProductContext();

  const NUMBER_OF_LEVELS = 3;
  const currentLevel = Math.min(numberOfItemsInCart, NUMBER_OF_LEVELS);

  const hasReachedMaxDiscount = currentLevel === NUMBER_OF_LEVELS;

  if (hasReachedMaxDiscount) return null;

  const upsellProductId = getCartUpsellProductId();

  const { title, productPageImages, price } =
    getProductData(upsellProductId) || {};

  if (!title) return null;

  const nextTierDiscountPercentage = getCartDiscountPercentage(
    numberOfItemsInCart + 1
  );
  const preDiscountPrice = price.amount;
  const discountedPrice =
    preDiscountPrice - preDiscountPrice * (nextTierDiscountPercentage / 100);

  const handleClick = () => {
    setCartUpsellProductIds([upsellProductId]);
    setIsCartUpsellWindowOpen(true);
  };

  const difference = preDiscountPrice - discountedPrice;

  return (
    <div className={styles.container}>
      <div className={styles.imageContainer}>
        {productPageImages?.[0]?.asset?.gatsbyImageData && (
          <GatsbyImage
            image={productPageImages?.[0].asset.gatsbyImageData}
            alt={title || ``}
          />
        )}
      </div>
      <div className={styles.textContent}>
        <div>
          <div className="h4">{title}</div>
          <div className={cn(`h4`, styles.prices)}>
            <span>${discountedPrice.toFixed(2)}</span>
            {` `}
            <span className={styles.strikethrough}>
              ${preDiscountPrice.toFixed(2)}
            </span>
          </div>
          <p className={styles.description}>
            Add to your cart to save ${difference.toFixed(2)}
          </p>
        </div>
        <div>
          <Button
            variant="caption"
            light
            iconRight="ArrowRight"
            onClick={handleClick}
          >
            Shop and save
          </Button>
        </div>
      </div>
    </div>
  );
};

export default CartUpsellCard;
